
import React from 'react';
import { connect } from "react-redux";
import { sprintf } from "sprintf-js";

class DashboardTableComponent extends React.Component {
  dumpCols = (row, rowIndex, num_rows) => {
    const num_cols = row.length;
    const evenWidth = 100. / num_cols;

    const tdStyle = {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      paddingRight: "0.5rem",
      cursor: "pointer"
    }
    if (rowIndex === 0) {
      tdStyle.vAlign = "bottom";
    }

    if (this.props.hLines) {
      tdStyle.borderBottom = "1pt solid black";
      tdStyle.paddingBottom = "0.5rem";
      tdStyle.paddingTop = "0.5rem";
    }
    if (this.props.even_cols) {
      tdStyle.width = sprintf("%f%%", evenWidth);
    }
    if (this.props.td_style) {
      Object.assign(tdStyle, this.props.td_style);
    }

    const tds = row.map((col, colIndex) => {
      const align = this.props.align ? this.props.align[colIndex] : "left";
      const currStyle = { ...tdStyle, };

      if (this.props.tdStyleLut) {
        this.props.tdStyleLut.forEach(rule => {
          if (rule.pred && rule.style && rule.pred(rowIndex, colIndex, num_rows, num_cols)) {
            Object.assign(currStyle, rule.style);
          } else if (rule.style_fn) {
            Object.assign(currStyle, rule.style_fn(rowIndex, colIndex));
          }
        });
      }

      return (
         <td
          style={currStyle}
          key={colIndex}
          align={align}
        >
          {col}
        </td>
      );
    })

    return tds;
  };

  onMouseRowEvent = (index, enter) => () => {
    if (this.props.onMouseRowEvent) {
      this.props.onMouseRowEvent(index, enter);
    }
  }

  onMouseRowClick = index => (ev) => {
    if (this.props.onMouseRowClick) {
      this.props.onMouseRowClick(index, ev);
    }
  }

  dumpRows = () => {
    const num_row = this.props.data.length;
    return this.props.data.map((row, index) => {
      const style = {
        ...this.props.tr_style,
      };
      if (this.props.underline_header && index === 0) {
        style.borderBottom = "1pt solid black";
      }
      return (
        <tr 
            key={index}
            style={style}
            onClick={this.onMouseRowClick(index)}
            onMouseEnter={this.onMouseRowEvent(index,true)}
            onMouseLeave={this.onMouseRowEvent(index, false)}
        >
          { this.dumpCols(row, index, num_row) }
        </tr>
      )
    })
  };

  maybeRenderColGroup = () => {
    if (!this.props.col_widths) {
      return null;
    }

    let full_width = 0.;

    this.props.col_widths.forEach(amt => {
      full_width += amt;
    });

    const cols = this.props.col_widths.map((amt, index) => {
      return (
        <col
          key={index}
          span={"1"}
          style={{width: sprintf("%f%%", amt / full_width * 100)}}/>);
    });

    return (
      <colgroup>
        { cols }
      </colgroup>
    );
  }

  render = () => {
    const tableStyle = {
      marginTop: "2rem",
      tableLayout: "fixed",
      ...this.props.tableStyle,
    };

    const tbody_style = {
      ...this.props.tbody_style,
    }

    return (
      <table style={tableStyle}>
        { this.maybeRenderColGroup() }
        <tbody style={tbody_style}>
        { this.dumpRows() }
        </tbody>
      </table>
    )
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
  }
}

export const DashboardTable = connect(mapStateToProps)(DashboardTableComponent);
